import systemapi from '@_system/api/api.js'
const modulesFiles = require.context('./api', true, /.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
	const moduleName = modulePath.replace(/\.\/(.*)\.js/, '$1')
	const value = modulesFiles(modulePath)
	value.default = {
		...systemapi.commonApi(value.default.path),
		...value.default
	}
	modules[moduleName] = value.default
	return modules
}, {})

export default {
	...systemapi,
	...modules
}